
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Route } from "vue-router";
import { LocalizableField } from "../../models/LocalizableField";

@Component
export default class PageTitleBar extends Vue {
  @Getter("isAuthenticated") private isAuthurized!: boolean;
  @Getter("eventTitle") private eventTitle!: string;

  private showTitle = false;
  private showDesktopTitle = false;

  created() {
    this.showTitle = this.$route["meta"].showTitleInMobile;
    this.showDesktopTitle = this.$route["meta"].showTitleInDesktop;
  }

  get pageTitle(): any {
    return this.$route.name ? this.$route.name : "";
  }

  returnToPrevious() {
    if (this.$route.meta && this.$route.meta.returnUrl) {
      this.$router.push(this.$route.meta.returnUrl);
    } else {
      this.$router.push("/");
    }
  }

  @Watch("$route")
  onRouteChanged(val: Route) {
    this.showTitle = val["meta"].showTitleInMobile;
    this.showDesktopTitle = val["meta"].showTitleInDesktop;
  }
}
